export default {
  props: ['id'],
  data() {
    return {
      survey: null,
      step: 1,
      questions: [],
      isValid: false,
      dialog: false,
      dialogText: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    loading() { return this.$store.state.loading; },
    checkAllValidate() { return !this.questions.filter(item => !item.isValid).length; },
  },
  methods: {
    setQuestions() {
      if ((JSON.stringify(this.survey) !== '{}') && this.survey.questions.length) {
        this.questions = [];
        for (let i = 0; i < this.survey.questions.length; i += 1) {
          this.questions.push({
            ...this.survey.questions[i],
            answer: {
              id: this.survey.questions[i].id,
              checked: (this.survey.questions[i].multiple) ? [] : 0,
              user_comment: '',
            },
            isValid: false,
          });
        }
      }
    },
    checkUserComment(item) {
      let require = false;
      if (item.answer.checked === 0 || item.answer.checked.length === 0) {
        require = true;
      }
      return require;
    },
    questionValidate(item) {
      let isValid = false;
      if (item.custom && item.answer.user_comment) {
        isValid = true;
      }
      if (!item.multiple && item.answer.checked) {
        isValid = true;
      }
      if (item.multiple && item.answer.checked.length) {
        isValid = true;
      }
      item.isValid = isValid;
      return isValid;
    },
    prevStep() {
      if (this.step > 1) {
        this.step = this.step - 1;
      }
    },
    nextStep() {
      if (this.survey.questions.length !== this.step) {
        this.step = this.step + 1;
      }
    },
    submit() {
      if (this.checkAllValidate) {
        const app = this;
        const survey = {
          profile_id: app.user.profile_id,
          survey_id: app.survey.id,
          type: 'answer',
          questions: {},
        };
        survey.questions = app.questions.map(item => item.answer);

        app.$store.getters.axl.post('survey/api/v3/surveys/survey-answer', survey)
          .then(({ data }) => {
            app.$store.dispatch('ShowInfo', 'Ваш опрос успешно отправлен');
            app.dialogText = data.message;
            app.dialog = true;
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('surveys/GetSurvey', this.$props.id * 1)
      .then((survey) => {
        this.$set(this.$data, 'survey', survey);
        this.setQuestions();
      })
      .catch(err => console.warn(err));
  },
};
